import { useEffect } from "react";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render/index";
import Et3PageTitle from "../../core/et3-page-title/index";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import ShareholderData from "./shareholder-data/index";
import ShareholderForm from "./shareholder-form/index";
import ET3PageDiv from "../../core/et3-page-div";
import Et3Margin from "../../core/et3-ui/ET3Margin";

const ShareholdersDashboard = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName("SHARE_HOLDER", "SHARE_HOLDER");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SHAREHOLDER_DASHBOARD")}
        subTitle={i18n.get("SHAREHOLDER_DASHBOARD")}
        withRefresh={false}
        withHelper={false}
        onPress={async () => {}}
      />
      <ShareholderForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ShareholderData />
    </ET3PageDiv>
  );
});

export default ShareholdersDashboard;
